import React from 'react';
import { useUpdateMembershipPerk, useGetMembershipPerk } from 'api/membership-perks';
import MembershipPerkForm from './membership-perk-form';
import { CircularProgress } from '@material-ui/core';
import { useHistory } from 'react-router';
import { useQueryClient } from 'react-query';
import MEMBERSHIP from '../../constants/MEMBERSHIP.gen';

const validTiers = new Set(Object.values(MEMBERSHIP.SUBSCRIPTION_TIERS));

function MembershipPerkEdit(props) {
  const id = props?.match?.params?.id;
  const queryClient = useQueryClient();
  const history = useHistory();
  const { mutate: updateMembershipPerk, isLoading: isSaving } = useUpdateMembershipPerk({
    onSuccess: async () => {
      await queryClient.invalidateQueries('getMembershipPerks');
      history.push('/membership-perks');
    },
  });

  const { data: values, isLoading } = useGetMembershipPerk(id);

  function onSave(values) {
    const sanitizedValues = Object.entries(values).reduce((newValues, [key, value]) => {
      if (key === 'membership_perk_id' || key === 'created_at' || key === 'updated_at') return newValues;
      if (key === 'tier') return { ...newValues, [key]: value.filter(x => validTiers.has(x)) };
      return { ...newValues, [key]: value || '' }; //some items are null but require a string. This makes it where you can 'clear' an optional
    }, {});
    updateMembershipPerk(sanitizedValues);
  }

  if (isLoading) return <CircularProgress />;
  return <MembershipPerkForm onSave={onSave} values={values} isSaving={isSaving} />;
}

export default MembershipPerkEdit;
